<div class="upcoming-appointment">
  <div class="ui-g-12 p-zero border-bottom-light pb-3 flex-column">
    <button id="upcoming-appt-btn-estimate-{{ tab }}"
      class="width-100p font-14 btn btn-primary btn-save btn-appt text-left" [disabled]="isEstimateCreating"
      (click)="createEstimate()">
      <div class="text-center">
        <span>
          <i class="fal fa-plus pr-6p"></i>
          <span [ngClass]="{ 'pr-2': isEstimateCreating }" class="font-700">Estimate</span>
        </span>

        <span>
          <i *ngIf="isEstimateCreating" class="fal fa-spinner rotate"></i>
        </span>
      </div>
    </button>

    <button id="upcoming-appt-btn-appointment-{{ tab }}"
      class="width-100p font-700 text-center font-14 btn btn-primary btn-save btn-appt text-left mb-2"
      (click)="openScheduleAppointmentModal()">
      <i class="fal fa-plus pr-6p"></i>
      Appointment
    </button>

    <button id="upcoming-appt-btn-credit-payment-{{ tab }}"
      class="width-100p font-700 text-center font-14 btn btn-primary btn-save btn-appt text-left"
      (click)="openCreditMemoModal()">
      <i class="fal fa-plus pr-6p"></i>
      Credit memo
    </button>
  </div>

  <div class="past-apt-wrapper">
    <app-fleet-customer *ngIf="_user?.isFleetCustomer" [user]="_user"></app-fleet-customer>
    <app-sidebar-upcoming-follow-up *ngIf="isMarketingEnabled" class="ui-g-12" [customer]="_user">
    </app-sidebar-upcoming-follow-up>

    <div class="ui-g-12 p-0 mt-2">
      <p class="appointment-heading text-left" *ngIf="pastAppts?.length === 0 || presentAppt?.length > 0">Appointments
      </p>
    </div>

    <div *ngIf="presentAppt?.length > 0">
      <div *ngFor="let appointment of presentAppt; let i = index">
        <app-appointment-card [appointment]="appointment" [index]="i" [tab]="tab"></app-appointment-card>
      </div>
    </div>

    <div class="no-appointment-section" *ngIf="!presentAppt?.length && !pastAppts?.length && !isLoadingAppointment">
      <div class="ui-g-12 text-center mt-3">
        <i class="fal fa-calendar-alt no-appointment-icon"></i>
      </div>
      <div class="ui-g-12 text-center mt-2">
        <p class="font-12 m-0 p-zero no-appointment-text">No appointments have been scheduled for this customer so far
        </p>
      </div>
    </div>

    <div class="no-appointment-section" *ngIf="isLoadingAppointment">
      <div class="ui-g-12 text-center mt-2 flex-center-center">
        <p class="font-12 m-0 no-appointment-text" [ngClass]="{ 'pr-2': isLoadingAppointment }">Loading</p>
        <i class="fal fa-spinner rotate"></i>
      </div>
    </div>

    <!-- Past Appointments Content Start -->
    <div class="past-appointment-section mt-2" *ngIf="pastAppts?.length">
      <div class="ui-g-12 p-0">
        <p class="appointment-heading text-left">Past Appointments</p>
      </div>
      <div class="" *ngFor="let appointment of pastAppts; let i = index">
        <app-appointment-card [appointment]="appointment" [isPast]="true" [index]="i" [tab]="tab">
        </app-appointment-card>
      </div>
    </div>
  </div>
</div>
